import React from 'react'
import { components, constants, useTranslation } from 'cng-web-lib'
import AciHighwayManifestApiUrls from 'src/apiUrls/AciHighwayManifestApiUrls'
import AciHighwayCargoApiUrls from 'src/apiUrls/AciHighwayCargoApiUrls'
import Table from '../../../../components/aciacehighway/Table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import _ from 'lodash'
import axios from 'axios'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import ACIHighwayManifestTranslationText from './../../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  CngDialog
} = components

const {
  filter: { LIKE, EQUAL, IN, BETWEEN }
} = constants

function AttachCargoDialog(props) {
  const {
    columns,
    manifestId,
    open,
    onAttachCargo,
    onClose,
    showNotification
  } = props

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  function handleSubmitSelectedCargo(rows) {
    const result = {
      manifestId,
      cargoId: rows.map((cargo) => cargo.id)
    }

    const instance = axios.create({
      withCredentials: false,
      headers: {
        Authorization:
          'Bearer ' + JSON.parse(localStorage.getItem('userToken')),
        'Content-Type': 'application/json'
      }
    })

    instance
      .post(AciHighwayManifestApiUrls.ATTACH, JSON.stringify(result))
      .then((res) => {
        const { errorMessages } = res.data

        if (res.status === 200 && !errorMessages) {
          showNotification('success', aciHighwayManifestTranslationText.attachCargoSuccessMsg)
          onAttachCargo()
        } else {
          showNotification('error', errorMessages)
        }

        onClose()
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const filters = [
    {
      label: aciHighwayManifestTranslationText.ccn,
      type: 'textfield',
      name: 'ccn',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.shipperName,
      type: 'textfield',
      name: 'shipperName',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.consigneeName,
      type: 'textfield',
      name: 'consigneeName',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.status,
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        {
          label: aciHighwayManifestTranslationText.draftStatus,
          value: 'draft',
          filterValue: {
            value: '1005'
          }
        },
        {
          label: aciHighwayManifestTranslationText.acceptedStatus,
          value: 'accepted',
          filterValue: {
            value: '1000'
          }
        },
        {
          label: aciHighwayManifestTranslationText.rejectedStatus,
          value: 'rejected',
          filterValue: {
            value: '1001'
          }
        },
        {
          label: aciHighwayManifestTranslationText.cancellationAcceptedStatus,
          value: 'cancellation_accepted',
          filterValue: {
            value: '1003'
          }
        },
        {
          label: aciHighwayManifestTranslationText.cancellationRejectedStatus,
          value: 'cancellation_rejected',
          filterValue: {
            value: '1004'
          }
        },
        {
          label: aciHighwayManifestTranslationText.modificationRejectedStatus,
          value: 'modification_rejected',
          filterValue: {
            value: '1007'
          }
        }
      ]
    },
    {
      label: aciHighwayManifestTranslationText.entryNo,
      type: 'textfield',
      name: 'entryNo',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.customsBroker,
      type: 'textfield',
      name: 'customsBroker',
      operatorType: LIKE
    },
    {
      label: aciHighwayManifestTranslationText.createdDate,
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
  ]

  return (
    <CngDialog
      dialogTitle={aciHighwayManifestTranslationText.attachCargoTitle}
      dialogContent={
        <Table
          checkboxSelection
          columns={columns}
          compact
          fetch={{ url: AciHighwayCargoApiUrls.GET }}
          fetchFilters={[
            { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() },
            { field: 'status', operator: IN, value: ['1005', '1000', '1001', '1003', '1004', '1007'] },
            { field: 'manifestId', operator: EQUAL, value: 'null' }
          ]}
          filters={filters}
          selectActions={[
            {
              disabled: (rows) => {
                let shouldDisable = false

                rows.forEach((rowData) => {
                  if (
                    rowData.status === '1008' ||
                    rowData.status === '1006' ||
                    rowData.status === '1002'
                  ) {
                    shouldDisable = true
                  }
                })

                return shouldDisable
              },
              icon: <FontAwesomeIcon icon={['fal', 'link']} />,
              label: aciHighwayManifestTranslationText.attach,
              onClick: (rows) => handleSubmitSelectedCargo(rows),
              tooltip: (rows) => {
                let includesSentRecords = false

                rows.forEach((rowData) => {
                  if (
                    rowData.status === '1008' ||
                    rowData.status === '1006' ||
                    rowData.status === '1002'
                  ) {
                    includesSentRecords = true
                  }
                })

                return includesSentRecords
                  ? aciHighwayManifestTranslationText.attachSentRecord
                  : null
              }
            }
          ]}
          search={{ field: 'ccn', operator: LIKE }}
          showNotification={showNotification}
          sortConfig={{
            type: 'column',
            defaultDirection: 'DESC',
            defaultField: 'updatedDate'
          }}
        />
      }
      dialogAction={
        <CngButton color='secondary' onClick={onClose}>
          {aciHighwayManifestTranslationText.discardButton}
        </CngButton>
      }
      fullWidth
      maxWidth='lg'
      open={open}
      onClose={onClose}
      shouldShowCloseButton
    />
  )
}

export default AttachCargoDialog
